// Shared URL normalization helpers.
// Kept intentionally tiny so multiple modals can reuse it without copying logic.

/**
 * Normalize a user-provided URL by ensuring it has an http/https protocol.
 * Mirrors the behavior used by AddContentModal.
 */
export function normalizeUrl(input: string): string {
  const trimmed = input.trim();
  if (!/^https?:\/\//i.test(trimmed)) {
    return `https://${trimmed.replace(/^\/+/, "")}`;
  }
  return trimmed;
}

